import React, { useEffect } from "react"
import { Rte } from "@capioweb/ui-components"
import { BlockCommonLayout } from "../../utils/layout"
import { PUBLIC_API_ENDPOINT, queryStaleTime } from "../../constants"
import { useQuery } from "react-query"
import { SiteSettingsProps } from "../Core/pageBase"
import { getContent } from "../../api"

const CapioCookieDeclarationBlock: React.FC = (props) => {
	const containerId = "cookiedeclarationcontainer"

	// Site settings query
	const { data: siteSettingsData } = useQuery<SiteSettingsProps>(
		"site",
		() => getContent(`${PUBLIC_API_ENDPOINT}/settings/site/`),
		{
			staleTime: queryStaleTime,
		}
	)
	const cookiebotID =
		siteSettingsData.cookiebotID ?? "65f3c763-5ad7-4429-84ae-ff66af9fbd25"

	useEffect(() => {
		const style = document.createElement("style")
		const head = document.getElementsByTagName("head")[0]
		style.setAttribute("type", "text/css")
		style.appendChild(
			document.createTextNode(`
				.CookieDeclaration [href*='//capio.se/cookies/'] {
					display: none;
					}
				`)
		)

		head.appendChild(style)

		return () => {
			document.getElementById(containerId).removeChild(style)
		}
	}, [])

	useEffect(() => {
		const script = document.createElement("script")
		script.src = `https://consent.cookiebot.com/${cookiebotID}/cd.js`
		script.id = "CookieDeclaration"
		script.async = true
		script.type = "text/javascript"

		document.getElementById(containerId).appendChild(script)

		return () => {
			document.getElementById(containerId).removeChild(script)
		}
	}, [])

	return (
		<BlockCommonLayout>
			<Rte>
				<div id={containerId}></div>
			</Rte>
		</BlockCommonLayout>
	)
}

export { CapioCookieDeclarationBlock }
